<!-- App.vue depicts the very first init Vue Single-File Components -->
<template>
  <router-view></router-view>
</template>
<script setup>
</script>